<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter" id="illus1">
<img alt="" class="calibre6" id="id-1251631314840333016" src="Images/img0001.jpg"/>
<p class="caption">TWILIGHT AT MIDDAY, FEBRUARY 1874.</p>
</div>
<p class="calibre3"><span id="pgepubid00004" title="[iv]"><a class="reference" id="Page_iv" title="[iv]"></a></span></p>
<p class="calibre3"><span id="pgepubid00005" title="[v]"><a class="reference" id="Page_v" title="[v]"></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?7c8ec587